import { Link2 } from 'lucide-react';
import { useState, type FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from '../../../components/ui/Button';
import { Input } from '../../../components/ui/Input';
import { useAuthStore } from '../../../store/authStore';

export function Hero() {
  const navigate = useNavigate();
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const [url, setUrl] = useState('');

  const onSubmit = (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const value = url.trim();
    if (!value) return;
    const encoded = encodeURIComponent(value);
    navigate(isAuthenticated ? `/app?new=1&url=${encoded}` : `/register?url=${encoded}`);
  };

  return (
    <section className="relative overflow-hidden bg-bg-deep">
      <div className="pointer-events-none absolute -left-40 -top-40 size-[560px] rounded-full bg-brand-teal/20 blur-3xl" aria-hidden />
      <div className="pointer-events-none absolute -right-48 top-1/3 size-[420px] rounded-full bg-brand-blue/10 blur-3xl" aria-hidden />

      <div className="relative mx-auto flex max-w-[1240px] flex-col items-center px-5 pb-14 pt-12 text-center sm:px-8 sm:pb-20 sm:pt-16">
        <span className="inline-flex items-center gap-2 rounded-full border border-brand-teal/30 bg-brand-teal/10 px-4 py-1.5 text-[13px] font-medium text-link">
          <span className="size-1.5 rounded-full bg-success" aria-hidden />
          Now with QR codes &amp; custom domains
        </span>

        <h1 className="mt-7 max-w-[860px] text-[40px] font-bold leading-[1.05] tracking-tight text-text sm:text-[64px] lg:text-[76px]">
          Short links that <span className="text-gradient-brand">measure</span> everything.
        </h1>

        <p className="mt-6 max-w-[680px] text-lg leading-relaxed text-text-2 sm:text-xl">
          Shorten, brand and track every link you share. Realtime analytics, QR codes and a clean API for your team.
        </p>

        <form
          onSubmit={onSubmit}
          className="mt-10 flex w-full max-w-[920px] flex-col gap-2 rounded-card border border-border bg-surface-2 p-2 shadow-card sm:flex-row sm:items-center"
          aria-label="Shorten a link"
        >
          <Input
            aria-label="Long URL"
            type="url"
            inputMode="url"
            placeholder="Paste a long URL…"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            leftIcon={<Link2 />}
            fieldSize="lg"
            wrapperClassName="flex-1"
            className="border-0 bg-transparent pl-11 text-base focus:shadow-none"
            required
          />
          <Button type="submit" size="lg" className="sm:w-auto">
            Shorten
          </Button>
        </form>

        <p className="mt-4 text-sm text-muted">Free plan · 100 links · No credit card</p>
      </div>
    </section>
  );
}
